import React from 'react';
import { CheckIcon } from 'lucide-react';
import { SectionHeading } from './SectionHeading';
import { tomos, tomoIncludes } from '../data/salesData';
export function TomosSection() {
  return <section className="border-b border-[var(--violet)]/30 py-16 sm:py-20" data-id="element-215" data-mp="1p320p9xzwyly">
      <div className="mx-auto max-w-6xl px-4" data-id="element-216" data-mp="1u2nbqiqfwxf1">
        <SectionHeading eyebrow="🦋 El sistema completo de 365 días" data-id="element-217" data-mp="1u1lq5kbsssj2">
          Sistema Keto 365
        </SectionHeading>
        <p className="mt-4 text-center text-white/70" data-id="element-218" data-mp="xe79pn658vl1">
          6 Tomos + 6 Bonos · Todo el año resuelto
        </p>

        <h3 className="mt-12 text-center text-sm font-semibold uppercase tracking-[0.25em] text-[var(--lilac)]" data-id="element-219" data-mp="11fsstq99u63o">
          Los 6 Tomos
        </h3>

        <div className="mt-6 grid gap-5 sm:grid-cols-2 lg:grid-cols-3" data-id="element-220" data-mp="1bd6wsqe0d2f3">
          {tomos.map(tomo => <article key={tomo.title} className="rounded-2xl border border-[var(--violet)]/40 bg-[#0d0819] p-6 transition-colors hover:border-[var(--lilac)]/70" data-id="element-221" data-mp="2hrfyppp33uxi">
              <span className="text-3xl" aria-hidden="true" data-id="element-222" data-mp="2qmxjntugn2wa">
                {tomo.emoji}
              </span>
              <h4 className="mt-4 font-display text-xl font-bold text-[var(--cream)]" data-id="element-223" data-mp="2mn58d9domin8">
                {tomo.title}
              </h4>
              <p className="mt-2 text-sm text-white/65" data-id="element-224" data-mp="2cofwbx8gvsew">{tomo.description}</p>
            </article>)}
        </div>

        <div className="mt-12 rounded-2xl border border-[var(--lilac)]/30 bg-[#16102e] p-6 sm:p-8" data-id="element-225" data-mp="27pmiu4t6k1eq">
          <h3 className="font-display text-2xl font-bold text-[var(--cream)]" data-id="element-226" data-mp="22ye895g469zz">
            Cada tomo incluye:
          </h3>
          <ul className="mt-6 grid gap-3 sm:grid-cols-2" data-id="element-227" data-mp="1yxu9jxfw6ybq">
            {tomoIncludes.map(item => <li key={item} className="flex items-start gap-3" data-id="element-228" data-mp="1tzj21td2kzwo">
                <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-[var(--violet)]/35" data-id="element-229" data-mp="1ozen47rt8d8k">
                  <CheckIcon className="h-4 w-4 text-[var(--lilac-light)]" aria-hidden="true" data-id="element-230" data-mp="1k13dny5fg4qv" />
                </span>
                <span className="text-white/80" data-id="element-231" data-mp="1fbj0px8xnp1t">{item}</span>
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}